import React, { useState, useContext } from 'react';
import './style.css';
import financingInfo from './financing_info.json';
import { CurlyBraceDivider } from '/src/Components/CurlyBraceDivider/CurlyBraceDivider';
import { MoveLeft } from 'lucide-react';
import { AddressSearchContext, WindowSizeContext } from '/src/App';
import ResourceCard from '/src/Components/ResourceCard/ResourceCard';


const FinancingItemsContainer = ({ items, showBracket = false, title = "", handleItemClick }) => {
    const { deviceType } = useContext(WindowSizeContext);

    // console.log(items);
    return (
        <div className="financing-info-items-frame">

            <div className={`financing-info-container-items-container ${deviceType}`}>
                {items.map((item, index) => {

                    const whoProvides = item.whoProvides;

                    let whoProvidesText = "";
                    if (whoProvides === "gov") {
                        whoProvidesText = "Government";
                    } else if (whoProvides === "lender") {
                        whoProvidesText = "Financial Institution";
                    } else if (whoProvides === "contractor") {
                        whoProvidesText = "Contractor + Partners";
                    }

                    return (
                        <div key={index} className="financing-info-item" onClick={() => handleItemClick(item.id)}>
                            <span className="financing-info-item-title">{item.title}</span>
                            <div className={`financing-info-item-who-provides ${whoProvides}`}>
                                {/* <span>{whoProvidesText}</span> */}
                            </div>
                        </div>
                    )
                })}
            </div>
            {showBracket && (
                <>
                    <div className="financing-info-container-items-container-bracket " />
                    <span className="financing-info-container-items-container-bracket-title">{title}</span>
                </>
            )}
        </div>
    );
};

const BeforeYouStart = () => {
    const { deviceType } = useContext(WindowSizeContext);

    const { portalData } = useContext(AddressSearchContext);
    const { resources } = portalData;

    console.log('resources ', resources);

    const [selectedItem, setSelectedItem] = useState(null);
    const [selectedItemResource, setSelectedItemResource] = useState(null);

    const handleItemClick = (id) => {

        console.log(id);
        // Filter the financingInfo array to get the item with the matching id
        const item = financingInfo.find(item => item.id === id);
        setSelectedItem(item);

        const resource = resources.find(resource => resource.id === item.resource_id);
        setSelectedItemResource(resource);
    };

    const handleBackButtonClick = () => {
        setSelectedItem(null);
        setSelectedItemResource(null);
    };

    // Get the items from the financialInfo array that have a WhenToGet value of "before"
    const beforeItems = financingInfo.filter(item => item.WhenToGet === "before");

    // Get the items from the financialInfo array that have a WhenToGet value of "long-term"
    const longTermItems = financingInfo.filter(item => item.WhenToGet === "long-term");

    // Get the items from the financialInfo array that have a WhenToGet value of "short-term"
    const shortTermItems = financingInfo.filter(item => item.WhenToGet === "short-term");

    const shortTermTitle = "For specific improvements"

    const longTermTitle = "For ongoing improvements"


    const financing_intro_sentence = "There are a number of ways for you to finance these improvements. Click on an option to learn more."
    const financing_conclusion_sentence = "Quoll does not endorse any specific financing option, we just want you to be informed. If you have any questions, please reach out to us and we'll be happy to help."

    // console.log(selectedItem);

    const legendItems = [
        {
            id: 'gov',
            title: "Government",
        },
        {
            id: 'lender',
            title: "Financial Institution",
        },
        {
            id: 'contractor',
            title: "Contractor + Partners",
        },
    ]
    return (
        <div className="taking-action-section-container">

            {!selectedItem ? (
                <>
                    <h1>Financing Options</h1>
                    <p className="financing-intro-sentence text-align-center" dangerouslySetInnerHTML={{ __html: financing_intro_sentence }} />
                    <div className={`financing-info-content-frame ${deviceType}`}>
                        <div className={`financing-info-content-legend ${deviceType}`}>
                            <span className="financing-info-content-legend-title">Financing Provider:</span>
                            <div className={`financing-info-content-legend-items-container ${deviceType}`}>
                                {legendItems.map((item, index) => {
                                    return (
                                        <div key={index} className="financing-info-content-legend-item">
                                            <div className={`financing-info-content-legend-item-color ${item.id}`} />
                                            <span>{item.title}</span>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>

                        <div className={`financing-info-container ${deviceType}`}>
                            <div className={`financing-info-container-individual-section ${deviceType}`}>

                                <div className={`financing-info-container-individual-section-individual-items ${deviceType}`}>
                                    <FinancingItemsContainer items={beforeItems} showBracket={false} handleItemClick={handleItemClick} />
                                </div>
                                <div className="financing-info-container-items-container-bracket big" />
                                <h4>If you're thinking about buying this home</h4>
                            </div>
                            <div className={`financing-info-container-right-column ${deviceType}`}>
                                <div className={`financing-info-container-right-column-items ${deviceType}`}>

                                    <div className={`financing-info-container-individual-section ${deviceType}`}>
                                        <FinancingItemsContainer items={shortTermItems} title={shortTermTitle} showBracket={true} handleItemClick={handleItemClick} />
                                    </div>
                                    <div className={`financing-info-container-individual-section ${deviceType}`}>
                                        <FinancingItemsContainer items={longTermItems} title={longTermTitle} showBracket={true} handleItemClick={handleItemClick} />
                                    </div>
                                </div>
                                <div className="financing-info-container-items-container-bracket big" />
                                <h4>If you own this home</h4>
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                <div className="financing-detailed-info-container">
                    <button className="financing-detailed-info-container-back-button" onClick={handleBackButtonClick}>
                        <div className="financing-detailed-info-container-back-button-icon">
                            <MoveLeft />
                        </div>
                        Back
                    </button>
                    <div className="financing-detailed-info-container-content">
                        <div className="financing-detailed-info-container-content-header">
                            <h3>{selectedItem.title}</h3>
                            <span>Provided by: {selectedItem.whoProvides === "gov" ? "Government" : selectedItem.whoProvides === "lender" ? "Financial Institution" : "Contractor + Partners"}</span>

                        </div>
                        {selectedItemResource && (
                            <div className="financing-detailed-info-container-content-resource-card-container">
                                <ResourceCard resource={selectedItemResource} showTags={false} />
                            </div>
                        )}
                        <p className="financing-detailed-info-container-content-description text-align-center" dangerouslySetInnerHTML={{ __html: selectedItem.description }} />
                        <div className={`financing-detailed-info-container-content-pros-cons-list-frame ${deviceType}`}>
                            <div className="financing-detailed-info-container-content-pros-cons-list-section">
                                <h4 className="financing-detailed-info-container-content-pros-cons-list-section-title pros">Pros</h4>
                                <ul>
                                    {selectedItem.pros.map((pro, index) => {
                                        return <li key={index}>{pro}</li>
                                    })}
                                </ul>
                            </div>
                            {deviceType !== 'mobile' && (
                                <div className="financing-detailed-info-container-content-pros-cons-list-section-vertical-divider" />
                            )}
                            <div className="financing-detailed-info-container-content-pros-cons-list-section">
                                <h4 className="financing-detailed-info-container-content-pros-cons-list-section-title cons">Cons</h4>
                                <ul>
                                    {selectedItem.cons.map((con, index) => {
                                        return <li key={index}>{con}</li>
                                    })}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <p className="financing-disclaimer-sentence text-align-center" dangerouslySetInnerHTML={{ __html: financing_conclusion_sentence }} />
        </div>
    );
};


export default BeforeYouStart;

